//build deploy
 import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

 const settings = {
 //   gọi đến AuthServer connect/authorize xong mới redirect về Login.js
     authority: 'https://api.authservice.cntt108.vn',       //your AuthServer
   client_id: 'client_qlcv_id',
 //   client_id: 'WebApiId1992',
 //   client_id: 'react_spa',
   redirect_uri: window.location.origin + '/callback',
   post_logout_redirect_uri: window.location.origin + '/',
   response_type: 'code',
   scope: 'openid profile roles offline_access qlcv_scope',
   userStore: new WebStorageStateStore({ store: window.localStorage }),
   automaticSilentRenew: true,
   silent_redirect_uri: window.location.origin + '/silent-renew.html',
   silentRequestTimeoutInSeconds: 10,
   accessTokenExpiringNotificationTimeInSeconds: 30,
 };

 export const userManager = new UserManager(settings);

 // convenience to read the currently signed in user
 export function getUser() {
   return userManager.getUser();
 }

////local test
// import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

// const settings = {
//   gọi đến AuthServer connect/authorize xong mới redirect về Login.js
//   authority: 'https:localhost:5003',       your AuthServer
//   client_id: 'react_spa',
//     client_id: 'WebApiId1992',
//     client_id: 'react_spa',
//   redirect_uri: window.location.origin + '/callback',
//   post_logout_redirect_uri: window.location.origin + '/',
//   response_type: 'code',
//   scope: 'openid profile roles offline_access webapi.access',
//   userStore: new WebStorageStateStore({ store: window.localStorage }),
//   automaticSilentRenew: true,
//   silent_redirect_uri: window.location.origin + '/silent-renew.html',
//   silentRequestTimeoutInSeconds: 10,
//   accessTokenExpiringNotificationTimeInSeconds: 30,
// };

// export const userManager = new UserManager(settings);

//// convenience to read the currently signed in user
//export function getUser() {
//   return userManager.getUser();
//}
